import axios from "axios";

export function getUsers(params) {
  return axios.get("/partner/admin/api/v1/users", { params });
}

export function createUser(data) {
  return axios.post("/partner/admin/api/v1/users", data);
}

export function updateUser(uuid, data) {
  return axios.put(`/partner/admin/api/v1/users/${uuid}`, data);
}

export function updateUserStatus(uuid, data) {
  return axios.put(`/partner/admin/api/v1/users/${uuid}/status`, data);
}

export function regenerateInvite(uuid) {
  return axios.post(`/partner/admin/api/v1/users/${uuid}/regenerate-invite`);
}

export function deleteUser(uuid) {
  return axios.delete(`/partner/admin/api/v1/users/${uuid}`);
}
